export function createIcon() {
  return {
    program: null,
    height: 0,
    width: 0,
    xPosition: 0,
    yPosition: 0,
    apiFramework: null,
    offset: null,
    duration: 0,
    type: null,
    staticResource: null,
    htmlResource: null,
    iframeResource: null,
    pxratio: '1',
    iconClickThroughURLTemplate: null,
    iconClickTrackingURLTemplates: [],
    iconViewTrackingURLTemplate: null,
  };
}
